import React, {Component} from 'react';
//CSS
import '../LandingSubcomponents/Marcas.css';
//Images
import ferne from '../../../assets/img/marcas/1882.jpg';
import axe from '../../../assets/img/marcas/axe.png';
import bacardi from '../../../assets/img/marcas/bacardi.png';
import baggio from '../../../assets/img/marcas/baggio.png';
import confort from '../../../assets/img/marcas/confort.png';
import dove from '../../../assets/img/marcas/dove.png';
import drlemon from '../../../assets/img/marcas/drlemon.png';
import gancia from '../../../assets/img/marcas/gancia.png';
import grupcepas from '../../../assets/img/marcas/grupcepas.jpg';
import hellmanns from '../../../assets/img/marcas/hellmanns.png';
import huggies from '../../../assets/img/marcas/huggies.jpg';
import kimber from '../../../assets/img/marcas/kiberly.png';
import kleenex from '../../../assets/img/marcas/kleenex.png';
import kotex from '../../../assets/img/marcas/kotex.png';
import life from '../../../assets/img/marcas/lifebuoy.png';
import lux from '../../../assets/img/marcas/lux.png';
import martini from '../../../assets/img/marcas/martini.png';
import pronto from '../../../assets/img/marcas/pronto.jpg';
import rexona from '../../../assets/img/marcas/rexona.png';
import scott from '../../../assets/img/marcas/scott.png';
import skip from '../../../assets/img/marcas/skip.png';
import unilev from '../../../assets/img/marcas/unilever.jpg';
import vivere from '../../../assets/img/marcas/vivere.png';
import knorr from '../../../assets/img/marcas/knorr.png';
import ala from '../../../assets/img/marcas/ala.png';
import cif from '../../../assets/img/marcas/cif.png';
import tacconi from '../../../assets/img/marcas/tacconi.png';
import terma from '../../../assets/img/marcas/terma.png';
import drive from '../../../assets/img/marcas/drive.png';
import impuls from '../../../assets/img/marcas/impulse.png';
import sedal from '../../../assets/img/marcas/sedal.png';
import suave from '../../../assets/img/marcas/suave.png';
import tresm from '../../../assets/img/marcas/tresseme.png';
import savora from '../../../assets/img/marcas/savora.png';
import delahuerta from '../../../assets/img/marcas/delahuerta.png';


class Marcas extends Component {
    render() {

        return (
            <div id="marcas" className="marcas">
                <h3 className="wow animated fadeIn" data-wow-duration="1s">
                    Las marcas más reconocidas
                </h3>
                <h6 className="wow animated fadeIn" data-wow-duration="1s">
                    Surtí tu comercio con bebidas, comestibles, productos de perfumería, limpieza y alimento para mascotas.
                </h6>
                <div className="container wow animated fadeIn" data-wow-duration="1s">
                    <div className="item">
                        <img src={axe} className="imagen" alt=""/>
                    </div>
                    <div className="item">
                        <img src={ferne} className="imagen" alt=""/>
                    </div>
                    <div className="item">
                        <img src={life} className="imagen" alt=""/>
                    </div>
                    <div className="item">
                        <img src={lux} className="imagen" alt=""/>
                    </div>
                    <div className="item">
                        <img src={baggio} className="imagen" alt=""/>
                    </div>
                    <div className="item">
                        <img src={confort} className="imagen" alt=""/>
                    </div>
                    <div className="item">
                        <img src={dove} className="imagen" alt=""/>
                    </div>
                    <div className="item">
                        <img src={gancia} className="imagen" alt=""/>
                    </div>
                    <div className="item">
                        <img src={grupcepas} className="imagen" alt=""/>
                    </div>
                    <div className="item">
                        <img src={hellmanns} className="imagen" alt=""/>
                    </div>

                    <div className="item">
                        <img src={huggies} className="imagen" alt=""/>
                    </div>
                    <div className="item">
                        <img src={kimber} className="imagen" alt=""/>
                    </div>
                    <div className="item">
                        <img src={kleenex} className="imagen" alt=""/>
                    </div>
                    <div className="item">
                        <img src={kotex} className="imagen" alt=""/>
                    </div>
                    <div className="item">
                        <img src={pronto} className="imagen" alt=""/>
                    </div>

                    <div className="item">
                        <img src={rexona} className="imagen" alt=""/>
                    </div>
                    <div className="item">
                        <img src={scott} className="imagen" alt=""/>
                    </div>
                    <div className="item">
                        <img src={skip} className="imagen" alt=""/>
                    </div>
                    <div className="item">
                        <img src={unilev} className="imagen" alt=""/>
                    </div>
                    <div className="item">
                        <img src={vivere} className="imagen" alt=""/>
                    </div>

                    <div className="item">
                        <img src={delahuerta} className="imagen" alt=""/>
                    </div>
                    <div className="item">
                        <img src={knorr} className="imagen" alt=""/>
                    </div>
                    <div className="item">
                        <img src={ala} className="imagen" alt=""/>
                    </div>
                    <div className="item">
                        <img src={cif} className="imagen" alt=""/>
                    </div>
                    <div className="item">
                        <img src={tacconi} className="imagen" alt=""/>
                    </div>
                    <div className="item">
                        <img src={terma} className="imagen" alt=""/>
                    </div>
                    <div className="item">
                        <img src={drive} className="imagen" alt=""/>
                    </div>
                    <div className="item">
                        <img src={impuls} className="imagen" alt=""/>
                    </div>
                    <div className="item">
                        <img src={sedal} className="imagen" alt=""/>
                    </div>
                    <div className="item">
                        <img src={suave} className="imagen" alt=""/>
                    </div>
                    <div className="item">
                        <img src={tresm} className="imagen" alt=""/>
                    </div>
                    <div className="item">
                        <img src={savora} className="imagen" alt=""/>
                    </div>
                </div>
            </div>
        );
    }
}


export default Marcas;


// WEBPACK FOOTER //
// ./src/pages/LandingPage/LandingSubcomponents/Marcas.js